<template>
  <div>
    <sFormItem
      prop="choosed"
      :rules="choosedRule">
      <sRadioGroup
        id="date-menu"
        v-model="choosed"
        class="mb-4 text-left"
        data-qa="radio-group-date-menu"
        style="width: 100%;">
        <div class="flex">
          <sRadio
            class="radio-date-type"
            data-qa="radio-group-for-all-no"
            :label="date_picker"
            style="margin: auto 0;">
            {{ }}
          </sRadio>
          <v-menu
            ref="menu"
            v-model="open_menu"
            :close-on-content-click="false"
            :return-value.sync="date_picker"
            z-index="1005">
            <template #activator=" { on }">
              <span v-on="on">
                <sInput
                  :disabled="choosed == 'U' || choosed == 'H'"
                  readonly
                  style="max-width: 200px;"
                  suffix-icon="calendar"
                  :value="formatDate(date_picker)">
                  <template #prepend>{{ $t('Common.DateTo') }}</template>
                </sInput>
              </span>
            </template>
            <v-date-picker
              v-model="date_picker"
              color="var(--v-secondary__green_not_active-base)"
              first-day-of-week="1"
              full-width
              :locale="$i18n.locale"
              :min="today"
              no-title
              scrollable
              :weekday-format="week"
              @change="$refs.menu.save(date_picker), choosed = date_picker"/>
          </v-menu>
        </div>
        <sRadio
          class="radio-date-type"
          data-qa="radio-group-for-all-no"
          label="U">
          {{ $t('Purchasing.Urgently') }}
        </sRadio>
        <div
          style="white-space: normal;">
          <transition name="s-zoom-in-top">
            <sFormItem
              v-show="choosed === 'U' && show_comment"
              class="why-urgent pl-3 mt-3"
              prop="comment"
              :rules="choosed === 'U' && show_comment ? commentValidateRule : null">
              <sInput
                :max-length="254"
                :placeholder="$t('Catalog.WhyUrgent')"
                type="textarea"
                :value.sync="comment_text"/>
            </sFormItem>
          </transition>
        </div>
        <sRadio
          class="radio-date-type"
          data-qa="radio-group-for-all-no"
          label="H">
          {{ $t('Catalog.NotImportantDate') }}
        </sRadio>
      </sRadioGroup>
    </sFormItem>
  </div>
</template>
<script>

import moment from 'moment'
import { filterSortMixin, modalMixin, validateRuls } from 'mixins'

export default {
  name: 'dateRadioMenu',
  mixins: [ filterSortMixin, modalMixin, validateRuls ],
  data() {
    const that = this
    return {
      today: moment().toISOString().substring(0, 10),
      date_picker: moment().toISOString().substring(0, 10),
      open_menu: false,
      choosedRule: {
        required: true,
        trigger: 'change',
        validator(rule, value, callback) {
          if (!that.choosed) {
            callback(new Error(that.$t('Tenders.ChooseWhenWantReceive')))
          }
          callback()
        },
      },
    }
  },
  props: {
    date: [String, Number],
    comment: String,
    show_comment: Boolean,
    item: Object,
    menu: Boolean,
  },
  created() {
    this.date_picker = this.choosed.length > 1 ? moment(this.choosed).format('YYYY-MM-DD') : ''
  },
  computed: {
    choosed: {
      get() {
        if ( moment(this.date).isValid() && this.date?.length > 1) {
          return moment(this.date).format('YYYY-MM-DD')
        }
        return this.date
      },
      set(value) {
        this.$emit('update:date', value + '')
      }
    },
    opened_menu: {
      get() {
        return this.menu
      },
      set(value) {
        this.$emit('update:menu', value)
      }
    },
    comment_text: {
      get() {
        return this.comment
      },
      set(value) {
        this.$emit('update:comment', value)
      }
    }
  },
  methods: {
    week(day) {
      return moment(day).format('dd')
    },
  },
}
</script>
<style lang="scss" scoped>
.radio-date-type {
  display: block;
}

.date.folder {
  height: 100%;
  width: 100%;
}
.chip {
  background-color: var(--white-color);
  font-weight: 400;
  height: 40px;
  border-width: 2px;
  border-radius: 31px;
  height: 40px;
  &.date-chip span:not(.black--text) {
    text-transform: none;
    opacity: 0.8;
  }
  img {
    width: 16px;
    height: 16px;
  }
}
.v-card__subtitle {
  text-align: start;
}
.open-picker {
  letter-spacing: 0.001em;
  &:before {
    background-color: var(--white-color);
  }
}
.apply-btn {
  height: 40px !important;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.03em;
}
.date-field {
  width: 172px !important;
}
</style>
<style lang="scss">
#date-menu{
  .why-urgent {
    .v-input__control {
      width: 231px;
    }
    fieldset {
      border: 2px solid var(--v-main__green-base) ;
      border-radius: 8px;
    }
  }
  .date-field  {
    // max-width: 541px;
    width: 172px !important;
    text-transform: none;
    letter-spacing: 0;
    height: 40px;
    font-size: 14px;
    display: flex;
    align-items: center;
    background: var(--white-color);
    border: 2px solid var(--v-main__green-base);
    border-radius: 31px;
    &.v-btn--disabled {
      opacity: 0.5;
      color: black !important;
    }
    .v-btn__content {
      width: 100%;
    }
    .prefix {
      // margin-top: 4px;
      // margin-right: 4px;
      color: rgba($color: var(--black-color), $alpha: 0.5);
    }
  }
}
</style>
